import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { VIEW_ONLY, NO_ACCESS } = PERMISSIONS_OPTIONS_VALUE;

export const WALLET_PERMISSIONS = {
  [VIEW_ONLY]: {
    DIM_RECHARGE_BALANCE: true,
    HIDE_EXPORT_BALANCE: true
  },
  [NO_ACCESS]: {
    DIM_RECHARGE_BALANCE: true
  }
};
